import { Component, EventEmitter, Input, Output, ViewEncapsulation, OnInit } from '@angular/core';

interface ToggleOption {
  viewValue: string;
  value: string;
}

@Component({
    selector: 'tidy-header-toggle',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./header-toggle.component.scss'],
    template: `
    <div class="header-div">
      @for (option of options; track option) {
        <div
          class="option-wrapper"
          [ngClass]="{'selected': selectedOption === option.value}"
          (click)="selectOption(option)">
          <tidy-text
            class="no-hover"
            [clickableBody]="option.viewValue">
          </tidy-text>
        </div>
      }
    </div>
    `,
    standalone: false
})
export class HeaderToggleComponent implements OnInit {
    
  @Input() options: ToggleOption[] = [];
  @Input() defaultOption?: string;
  @Output() optionSelected = new EventEmitter<string>();

  selectedOption: string;

  ngOnInit() {
    this.selectedOption = this.defaultOption || (this.options[0]?.value ?? '');
  }

  selectOption(option: ToggleOption) {
    this.selectedOption = option.value;
    this.optionSelected.emit(option.value);
  }
} 